import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/700.css'
import App from './App.tsx'
import './index.css'

// Development-only accessibility auditing. Never bundled into production.
if (import.meta.env.DEV) {
  void (async () => {
    const [React, ReactDOM, axe] = await Promise.all([
      import('react'),
      import('react-dom'),
      import('@axe-core/react'),
    ])
    axe.default(React, ReactDOM, 1000)
  })()
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
